export default "__VITE_ASSET__DRMQuxdW__"